import cn from 'classnames';
import { CmsBhImageLink } from 'models/CmsBhImageLink';
import styles from './imageLinks.scss';
import Image from 'components/Shared/Image';
import { Section } from 'components/Section';
import { rm } from 'utils';
import { SrcSet } from 'components/Shared/Image/SrcSet';

const VIEW_WIDTH_1_OF_1 = 1500;
const VIEW_WIDTH_3_OF_4 = 1121;
const VIEW_WIDTH_2_OF_3 = 995;
const VIEW_WIDTH_1_OF_2 = 742;
interface OwnProps {
  imageLinks: CmsBhImageLink[];
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type OverrideStyleInterface = any;
const _styles: OverrideStyleInterface = styles;
// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-return
const getClassName = (className: string): string => _styles[className] || '';

const getResponsive = (className: string, width: number, height: number) => {
  const viewWidth = getViewWith(className);
  const sizes: { [key: string]: SrcSet } = {
    default: {
      viewWidth,
      width: viewWidth,
      height: (viewWidth / width) * height
    }
  };

  return {
    srcSet: Object.values(sizes),
    sizes: `${sizes.default.width}px`
  };
};

function getViewWith(className: string) {
  if (className === 'linkWidth3of4') {
    return VIEW_WIDTH_3_OF_4;
  }
  if (className === 'linkWidth2of3') {
    return VIEW_WIDTH_2_OF_3;
  }
  if (className === 'linkWidth1of2') {
    return VIEW_WIDTH_1_OF_2;
  }
  return VIEW_WIDTH_1_OF_1;
}

export const ImageLinks = ({ imageLinks }: OwnProps) => (
  <Section title={rm('brand_content_image_links_title')} className={styles.imageLinksWrapper}>
    <div className={styles.content}>
      {imageLinks.map(({ url, cssClass, width, height, ...image }) => {
        return (
          <a
            key={image.id}
            href={url}
            className={cn(getClassName(cssClass), styles.imageLinkWrapper)}
          >
            <Image
              wrapperStyle={{ width: '100%' }}
              className={styles.imageLink}
              {...image}
              width={width}
              height={height}
              paddingBottom
              responsive={getResponsive(cssClass, width, height)}
            />
          </a>
        );
      })}
    </div>
  </Section>
);
